/**
 * @package     Com3elles 3D viewer field for Joomla!
 * @copyright   Copyright (c)2024 Com3elles / Shane Vanhoeck
 * @license     GNU General Public License version 3, or later
 */

const toggleFullScreenBtns = document.querySelectorAll('.tdv_toggle-fullscreen-btn');

toggleFullScreenBtns.forEach(btn => {
    btn.addEventListener('click', function () {
        const target = this.closest('.tdv_item-card');

        if (!target) {
            throw new Error('Can not set fullscreen, cause: Target not found');
        }

        if (!document.fullscreenElement) {
            target.requestFullscreen()
                .catch((err) => {
                    alert(
                        `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`
                    );
                });
        } else {
            document.exitFullscreen();
        }
    });
});